import { ceil } from 'lodash-es';

export const getLockedAccountCountdown = () =>
  ceil(
    Number(
      JSON.parse(sessionStorage.getItem('lockedAccountCountdown') || '300')
    ) / 60,
    2
  );
